// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOSMultiselect-module_list_t5u2X {
  width: 100%;
}

.BOSMultiselect-module_row__qpdN {
  height: 100%;
  align-items: center;
  padding: 0;
}

.BOSMultiselect-module_row__qpdN li {
  width: 100%;
}

.BOSMultiselect-module_inactive_p6tYL {
}

.BOSMultiselect-module_no_content_LBwVo {
  font-style: italic;
  color: var(--bp-gray3) !important;
}

.BOSMultiselect-module_tag_box_z_567 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.BOSMultiselect-module_tag_box_z_567 span {
  line-height: 16px;
}

.BOSMultiselect-module_filter_label_input_box_qIxcV {
}

.BOSMultiselect-module_filter_label_header_box_RpdWP {
}

.BOSMultiselect-module_filter_suggest_selection_box_YANnS {
  justify-content: start;
}

.BOSMultiselect-module_filter_suggest_selection_box_YANnS:focus-within {
  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgb(45 114 210 / 30%),
    inset 0 1px 1px rgb(17 20 24 / 20%);
}

.BOSMultiselect-module_filter_suggest_input_AJGqr input {
  width: 100%;
  padding: 0;
  box-shadow: none;
  background: none;
}

.BOSMultiselect-module_filter_suggest_input_AJGqr input:focus {
  box-shadow: none;
  border: none;
}

.BOSMultiselect-module_filter_suggest_input_narrow_YTjzy {
  width: 20px;
}

.BOSMultiselect-module_overflow_list_WNasr {
  gap: 4px;
}

.BOSMultiselect-module_overflow_tag_cBA4j {
}

.BOSMultiselect-module_overflow_tag_cBA4j > span:first-child {
  margin-right: 0;
}

.BOSMultiselect-module_overflow_tag_with_clear_BcRgg {
  min-width: 56px !important;
}

.BOSMultiselect-module_overflow_menu_tag_RvqsV {
  margin: 6px 0;
  width: 100%;
  cursor: default !important;
}

.BOSMultiselect-module_filter_selection_menu_popover_KoXBQ {
}

.BOSMultiselect-module_clear_button_GtwSd {
  margin-left: auto;
  margin-right: -8px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/BOSMultiselect/BOSMultiselect.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE;uCACqC;AACvC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;AACA;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;AAEA;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".list {\n  width: 100%;\n}\n\n.row {\n  height: 100%;\n  align-items: center;\n  padding: 0;\n}\n\n.row li {\n  width: 100%;\n}\n\n.inactive {\n  composes: inactive from 'Styles/styles.module.css';\n}\n\n.no_content {\n  font-style: italic;\n  color: var(--bp-gray3) !important;\n}\n\n.tag_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tag_box span {\n  line-height: 16px;\n}\n\n.filter_label_input_box {\n  composes: filter_label_input_box from 'Styles/styles.module.css';\n}\n\n.filter_label_header_box {\n  composes: filter_label_header_box from 'Styles/styles.module.css';\n}\n\n.filter_suggest_selection_box {\n  composes: tag_box;\n  justify-content: start;\n}\n\n.filter_suggest_selection_box:focus-within {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgb(45 114 210 / 30%),\n    inset 0 1px 1px rgb(17 20 24 / 20%);\n}\n\n.filter_suggest_input input {\n  width: 100%;\n  padding: 0;\n  box-shadow: none;\n  background: none;\n}\n\n.filter_suggest_input input:focus {\n  box-shadow: none;\n  border: none;\n}\n\n.filter_suggest_input_narrow {\n  width: 20px;\n}\n\n.overflow_list {\n  gap: 4px;\n}\n\n.overflow_tag {\n}\n\n.overflow_tag > span:first-child {\n  margin-right: 0;\n}\n\n.overflow_tag_with_clear {\n  composes: overflow_tag;\n  min-width: 56px !important;\n}\n\n.overflow_menu_tag {\n  margin: 6px 0;\n  width: 100%;\n  cursor: default !important;\n}\n\n.filter_selection_menu_popover {\n  composes: filter_selection_menu from 'Styles/styles.module.css';\n}\n\n.clear_button {\n  margin-left: auto;\n  margin-right: -8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `BOSMultiselect-module_list_t5u2X`,
	"row": `BOSMultiselect-module_row__qpdN`,
	"inactive": `BOSMultiselect-module_inactive_p6tYL ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inactive"]}`,
	"no_content": `BOSMultiselect-module_no_content_LBwVo`,
	"tag_box": `BOSMultiselect-module_tag_box_z_567`,
	"filter_label_input_box": `BOSMultiselect-module_filter_label_input_box_qIxcV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["filter_label_input_box"]}`,
	"filter_label_header_box": `BOSMultiselect-module_filter_label_header_box_RpdWP ${___CSS_LOADER_ICSS_IMPORT_0___.locals["filter_label_header_box"]}`,
	"filter_suggest_selection_box": `BOSMultiselect-module_filter_suggest_selection_box_YANnS BOSMultiselect-module_tag_box_z_567`,
	"filter_suggest_input": `BOSMultiselect-module_filter_suggest_input_AJGqr`,
	"filter_suggest_input_narrow": `BOSMultiselect-module_filter_suggest_input_narrow_YTjzy`,
	"overflow_list": `BOSMultiselect-module_overflow_list_WNasr`,
	"overflow_tag": `BOSMultiselect-module_overflow_tag_cBA4j`,
	"overflow_tag_with_clear": `BOSMultiselect-module_overflow_tag_with_clear_BcRgg BOSMultiselect-module_overflow_tag_cBA4j`,
	"overflow_menu_tag": `BOSMultiselect-module_overflow_menu_tag_RvqsV`,
	"filter_selection_menu_popover": `BOSMultiselect-module_filter_selection_menu_popover_KoXBQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["filter_selection_menu"]}`,
	"clear_button": `BOSMultiselect-module_clear_button_GtwSd`
};
export default ___CSS_LOADER_EXPORT___;
